import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
export const FaqSection = () => {
  const faqs = [{
    q: '¿Cómo recibo BIO-SYNC después de comprar?',
    a: 'Inmediatamente después del pago recibirás un email con el acceso a todos los archivos PDF. En menos de 5 minutos tenés todo disponible para descargar y empezar a usar.'
  }, {
    q: '¿Para qué edad está pensado BIO-SYNC?',
    a: 'Para adolescentes de 13 a 18 años. El lenguaje, el diseño y los protocolos están creados específicamente para esta etapa de desarrollo.'
  }, {
    q: '¿Es editable? ¿Puedo modificarlo?',
    a: 'BIO-SYNC se entrega en formato PDF listo para usar. No requiere edición. Está diseñado para ser usado directamente por el adolescente.'
  }, {
    q: '¿Los 3 bonos están incluidos siempre?',
    a: 'Sí. Los 3 bonos están incluidos en la única opción disponible. No hay compras adicionales necesarias.'
  }, {
    q: '¿Sirve si mi hijo/a no quiere hablar de sus emociones?',
    a: 'BIO-SYNC está diseñado para adolescentes que no quieren hablar. Es un sistema que pueden usar solos sin necesidad de abrirse a nadie. Eso es exactamente su ventaja.'
  }, {
    q: '¿Funciona para adolescentes con ansiedad severa?',
    a: 'BIO-SYNC es una herramienta de desarrollo emocional y bienestar. Para casos de ansiedad severa se recomienda combinarlo con apoyo profesional especializado.'
  }, {
    q: '¿Necesita internet para usarlo?',
    a: 'No. Una vez descargado funciona completamente sin internet. Puede usarse en cualquier dispositivo que abra archivos PDF.'
  }, {
    q: '¿Es diferente a otros libros de autoayuda para adolescentes?',
    a: 'BIO-SYNC no es un libro para leer. Es un sistema de acción. Cada módulo tiene protocolos, actividades, fichas de emergencia y planes de acción concretos. El adolescente hace. No solo lee.'
  }, {
    q: '¿Cuánto tiempo necesita dedicarle cada día?',
    a: 'Los protocolos de mantenimiento requieren 5 minutos diarios. Las actividades de cada módulo se completan en 15-20 minutos. El sistema está diseñado para la realidad del tiempo adolescente.'
  }, {
    q: '¿Tiene garantía real?',
    a: 'Sí. 7 días de garantía total sin preguntas ni formularios. Si no es lo que esperabas te devolvemos el 100% del pago.'
  }, {
    q: '¿Qué métodos de pago aceptan?',
    a: 'Podés pagar con Tarjeta de Crédito, Débito o Transferencia (Mercado Pago / Ualá). El pago es 100% seguro y el acceso es inmediato en menos de 5 minutos.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="bg-white py-10 px-5 sm:px-10" data-id="element-86">
      <div className="max-w-[800px] mx-auto" data-id="element-87">
        <h2 className="text-3xl sm:text-4xl font-bold text-center text-biosync-text mb-12" data-id="element-88">
          "❓ PREGUNTAS FRECUENTES"
        </h2>

        <div className="space-y-4" data-id="element-89">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={i} className={`border rounded-xl overflow-hidden transition-colors duration-300 ${isOpen ? 'border-biosync shadow-sm' : 'border-gray-200'}`} data-id="element-90">
                <button className="w-full px-6 py-4 text-left flex justify-between items-center bg-white hover:bg-gray-50 transition-colors" onClick={() => setOpenIndex(isOpen ? null : i)} data-id="element-91">
                  <span className="font-bold text-biosync-text pr-4" data-id="element-92">
                    {faq.q}
                  </span>
                  <span className={`text-xl text-biosync transition-transform duration-300 ${isOpen ? 'rotate-45' : ''}`} data-id="element-93">
                    +
                  </span>
                </button>
                <AnimatePresence data-id="element-94">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-95">
                      <div className="px-6 pb-5 pt-1 text-biosync-textSec text-sm sm:text-base leading-relaxed border-t border-gray-100" data-id="element-96">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
};